import { render, staticRenderFns } from "./AdminRoleSearch.filter.vue?vue&type=template&id=53f47ff0&"
import script from "./AdminRoleSearch.filter.vue?vue&type=script&lang=ts&"
export * from "./AdminRoleSearch.filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports